import React from "react";
import "./GitchaConsumerTag.scss";

export const CONSUMER_USER_TYPE = 1;

export const isGitchaConsumer = (person) => Number(person?.userTypeId ?? person?.UserTypeId) === CONSUMER_USER_TYPE;

export const consumerLine = (source) => {
  if (source === "showcase") return "Home shopper, from your website showcase";
  if (source === "gitcha_bio") return "Home shopper on Gitcha.com, from your Gitcha bio";
  return "Home shopper on Gitcha.com, not an agent";
};

const GitchaConsumerTag = ({ person, source, variant = "row" }) => {
  if (!isGitchaConsumer(person)) return null;
  if (variant === "row") return <span className="gitcha-consumer-tag">Gitcha.com</span>;
  return <p className="gitcha-consumer-tag__line">{consumerLine(source)}</p>;
};

export default GitchaConsumerTag;
